import React, { lazy, Suspense, useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from '../../app/LanguageContext';

const PriceSimulatorDialog = lazy(() => import('./PriceSimulatorDialog'));
const SavedSimulationViewDialog = lazy(() => import('./SavedSimulationViewDialog'));

export default function PriceSimulatorTriggerButton({
  description,
  quantity,
  initialSellingPriceUnit = null,
  initialSellingPriceTotal = null,
  savedSimulation = null,
  defaultVariableCosts = [],
  onApplySimulatedPrice,
  attachHistoryAssets = false,
  productName = '',
  skuCode = '',
  skuAttributes = null,
  showTrigger = true,
}) {
  const { translate } = useTranslation();
  const [simulatorOpen, setSimulatorOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const itemContext = {
    productName,
    skuCode,
    skuAttributes,
    itemDescription: description ?? '',
  };

  return (
    <>
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
        {savedSimulation ? (
          <Tooltip title={translate('extensions.price_simulator.view_saved_simulation_tooltip')}>
            <IconButton
              size="small"
              edge="end"
              color="info"
              onClick={() => setViewOpen(true)}
              aria-label={translate('extensions.price_simulator.view_saved_simulation_tooltip')}
              sx={{ p: 0.5, flexShrink: 0 }}
            >
              <InfoOutlinedIcon sx={{ fontSize: '1.15rem' }} />
            </IconButton>
          </Tooltip>
        ) : null}

        {showTrigger ? (
          <Tooltip title={translate('extensions.price_simulator.trigger_tooltip')}>
            <IconButton
              size="small"
              edge="end"
              color="primary"
              onClick={() => setSimulatorOpen(true)}
              aria-label={translate('extensions.price_simulator.trigger_tooltip')}
              sx={{ p: 0.5, flexShrink: 0 }}
            >
              <CalculateOutlinedIcon sx={{ fontSize: '1.15rem' }} />
            </IconButton>
          </Tooltip>
        ) : null}
      </Box>

      {simulatorOpen && showTrigger ? (
        <Suspense fallback={null}>
          <PriceSimulatorDialog
            open
            onClose={() => setSimulatorOpen(false)}
            initialDescription={description ?? ''}
            initialQuantity={quantity ?? 1}
            initialSellingPriceUnit={initialSellingPriceUnit}
            initialSellingPriceTotal={initialSellingPriceTotal}
            savedSimulation={savedSimulation}
            defaultVariableCosts={defaultVariableCosts}
            attachHistoryAssets={attachHistoryAssets}
            onApplySimulatedPrice={onApplySimulatedPrice}
            itemContext={itemContext}
          />
        </Suspense>
      ) : null}

      {viewOpen && savedSimulation ? (
        <Suspense fallback={null}>
          <SavedSimulationViewDialog
            open
            onClose={() => setViewOpen(false)}
            savedSimulation={savedSimulation}
          />
        </Suspense>
      ) : null}
    </>
  );
}
